module.exports = __webpack_public_path__ + "img/british-virgin-islands.2869c0fb.svg";